import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col pb-12" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "capitalize text-current" }, "Sidewalk tradeoffs evaluation", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, " The Sidewalk Tradeoffs Evaluation Tool can be used to visualize the tradeoffs when constructing or maintaining a less than standard sidewalk with private development or a city project. It can also be used to determine whether additional priority needs to be placed on finding opportunities for greening (i.e., street trees and stormwater swales). ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, " To use the tool, select the street type that the project is on and whether it is in a pedestrian district. This will populate the City's standards for the furnishing, pedestrian, and frontage zones of the sidewalk. You can then enter the proposed widths for each sidewalk zone to see the tradeoffs of non-standard sidewalk widths. ", -1)
const _hoisted_5 = { class: "prose prose-lg px-4 max-w-7xl" }
const _hoisted_6 = { class: "flex flex-col md:flex-row gap-4 px-4" }
const _hoisted_7 = { class: "flex-1 grid md:grid-rows-[11rem_1fr]" }
const _hoisted_8 = { class: "flex flex-col" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "font-semibold" }, "Street type", -1)
const _hoisted_10 = ["value", "selected"]
const _hoisted_11 = { class: "flex flex-col" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "font-semibold" }, "Pedestrian district", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "hidden" }, "Pedestrian district", -1)
const _hoisted_14 = { class: "flex flex-col gap-4" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("dt", { class: "font-semibold" }, "Standard width", -1)
const _hoisted_16 = { class: "grid grid-cols-2 gap-2" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("dt", { class: "font-semibold" }, "Alternative width", -1)
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<div class=\"flex-1 grid md:grid-rows-[minmax(min-content,_11rem)_1fr]\"><h3 class=\"font-bold\">Curb</h3><dl class=\"flex flex-col gap-4\"><div><dt class=\"font-semibold\">Standard width</dt><dd class=\"grid grid-cols-2 gap-2\">0.5 feet</dd></div><div><dt class=\"font-semibold\">Alternative width</dt><dd class=\"grid grid-cols-2 gap-2\">0.5 feet</dd></div></dl></div>", 1)

import { computed, ref, toRefs } from 'vue';
import {
  LocationAsRelativeRaw,
  RouteLocationOptions,
  RouteQueryAndHash,
  useRoute,
  useRouter,
} from 'vue-router';

import Anchor from '@/elements/anchor/Anchor.vue';
import Image from '@/elements/img/Image.vue';
import Portion from './Portion.vue';
import Select from '@/elements/inputs/Select.vue';
import Toggle from '@/elements/inputs/Toggle.vue';
import { useClassificationStore } from '@/store/classification';
import { useSidewalk } from '@/composables/sidewalk-tradeoff';
import Box from '@/elements/box/Box';


export default /*#__PURE__*/_defineComponent({
  __name: 'Page',
  props: {
  width: { type: Number, required: true },
  pedestrianDistrict: { type: Boolean, default: false },
  streetType: { type: String as () => 'CIMS', default: 'CIMS' },
},
  setup(__props) {

const props = __props;

const { pedestrianDistrict, streetType } = toRefs(props);

const route = useRoute();
const router = useRouter();
const store = useClassificationStore();
const { sidewalk } = useSidewalk(streetType, pedestrianDistrict);

const frontage = ref(0);
const pedestrian = ref(0);
const furnishings = ref(0);

const publicPath = process.env.BASE_URL;

// watchEffect(() => {
frontage.value = sidewalk.value?.frontage.standardWidth || 0;
pedestrian.value = sidewalk.value?.pedestrians.standardWidth || 0;
furnishings.value = sidewalk.value?.furnishings.standardWidth || 0;
// });

const streetTypes = computed(() =>
  store.models
    .filter((m) => m.group == 'design')
    .filter((m) => m.value != 'UT')
    .sort((a, b) => {
      const order = ['CMS', 'CIC', 'NMS', 'NC', 'CC', 'LS', 'IR', 'RC', 'UT'];
      return (
        order.findIndex((o) => o == a.value) -
        order.findIndex((o) => o == b.value)
      );
    })
);

const standardWidth = computed(
  () =>
    (sidewalk.value?.frontage.standardWidth || 0) +
    (sidewalk.value?.pedestrians.standardWidth || 0) +
    (sidewalk.value?.furnishings.standardWidth || 0) +
    (sidewalk.value?.curb.standardWidth || 0)
);

const totalWidth = computed(
  () =>
    frontage.value +
    pedestrian.value +
    furnishings.value +
    (sidewalk.value?.curb.standardWidth || 0)
);

const changeQuery = (query: Record<string, string>) => {
  changeRoute({
    query: {
      ...route.query,
      ...query,
    },
  });
};

const changeRoute = (
  to: RouteQueryAndHash & LocationAsRelativeRaw & RouteLocationOptions
) => {
  router.replace({
    name: route.name || 'SidewalkTradeoffs',
    query: {
      ...route.query,
      ...to.query,
    },
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createVNode(_unref(Box), {
      as: "header",
      class: "flex flex-col gap-4 mb-8"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Box), {
          as: "main",
          class: "prose prose-lg px-4"
        }, {
          default: _withCtx(() => [
            _hoisted_2,
            _hoisted_3,
            _hoisted_4,
            _createElementVNode("p", null, [
              _createTextVNode(" This tool is a representation of information provided in the city's "),
              _createVNode(Anchor, { url: "//www.portland.gov/sites/default/files/2022/PBOT Pedestrian Design Guide 2022.pdf" }, {
                default: _withCtx(() => [
                  _createTextVNode("Pedestrian Design Guide.")
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }),
        _createElementVNode("figure", _hoisted_5, [
          _createVNode(Image, {
            src: `${_unref(publicPath)}img/sidewalk-tradeoffs/zones.webp`
          }, null, 8, ["src"])
        ])
      ]),
      _: 1
    }),
    _createElementVNode("main", _hoisted_6, [
      _createElementVNode("section", _hoisted_7, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode(Select, {
              id: "type",
              name: "type",
              class: "w-full",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (changeQuery({ streetType: $event })))
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(streetTypes.value, (x, i) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: i,
                    value: x.value,
                    selected: x.value == _unref(streetType)
                  }, _toDisplayString(x.label), 9, _hoisted_10))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode(Toggle, {
              id: "pedestrianDistrict",
              label: "Pedestrian district",
              "true-label": "yes",
              "false-label": "no",
              modelValue: _unref(pedestrianDistrict),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (
                changeQuery({ pedestrianDistrict: String($event) })
              ))
            }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("dl", _hoisted_14, [
          _createElementVNode("div", null, [
            _hoisted_15,
            _createElementVNode("dd", _hoisted_16, _toDisplayString(standardWidth.value) + " feet ", 1)
          ]),
          _createElementVNode("div", null, [
            _hoisted_17,
            _createElementVNode("dd", null, _toDisplayString(totalWidth.value.toFixed(1)) + " feet", 1)
          ])
        ])
      ]),
      (_unref(sidewalk)?.frontage)
        ? (_openBlock(), _createBlock(Portion, {
            key: 0,
            label: "Frontage Zone",
            maxWidth: 2.5,
            portion: _unref(sidewalk).frontage,
            onChanged: _cache[2] || (_cache[2] = ($event: any) => (frontage.value = $event)),
            class: "flex-1 grid md:grid-rows-[minmax(min-content,_11rem)_1fr]"
          }, null, 8, ["portion"]))
        : _createCommentVNode("", true),
      (_unref(sidewalk)?.pedestrians)
        ? (_openBlock(), _createBlock(Portion, {
            key: 1,
            label: "Pedestrian Through Zone (PTZ)",
            maxWidth: 8,
            portion: _unref(sidewalk).pedestrians,
            onChanged: _cache[3] || (_cache[3] = ($event: any) => (pedestrian.value = $event)),
            class: "flex-1 grid md:grid-rows-[minmax(min-content,_11rem)_1fr]"
          }, null, 8, ["portion"]))
        : _createCommentVNode("", true),
      (_unref(sidewalk)?.furnishings)
        ? (_openBlock(), _createBlock(Portion, {
            key: 2,
            label: "Furnishing Zone",
            maxWidth: 6,
            portion: _unref(sidewalk).furnishings,
            onChanged: _cache[4] || (_cache[4] = ($event: any) => (furnishings.value = $event)),
            class: "flex-1 grid md:grid-rows-[minmax(min-content,_11rem)_1fr]"
          }, null, 8, ["portion"]))
        : _createCommentVNode("", true),
      _hoisted_18
    ])
  ]))
}
}

})